module.exports = __webpack_public_path__ + "img/digtal-title.712d7e3d.png";